function focusElement(elementId) {
  const element = document.getElementById(elementId)

  if (element === null) {
    return
  }

  if (element.getAttribute('tabindex') === '-1') {
    element.setAttribute('tabindex', 0)
  }

  if (element) {
    element.addEventListener(
      'focus',
      (event) => {
        event.preventDefault()
      },
      { once: true }
    )

    element.focus()
  }
}

export function blurActiveElement() {
  const activeTextarea = document.activeElement

  if (activeTextarea && activeTextarea instanceof HTMLElement && document.hasFocus()) {
    activeTextarea.blur()
  }
}

export function setFocusForAccessibility(
  elementId: string,
  timeOut = 10,
  refocus = true,
  cancelCurrentFocus = true
) {
  if (!refocus && document.activeElement?.getAttribute('id') === elementId) {
    return
  }

  if (cancelCurrentFocus) {
    blurActiveElement()
  }

  if (timeOut === null) {
    focusElement(elementId)
    return
  }

  setTimeout(() => {
    focusElement(elementId)
  }, timeOut)
}

export function blockFocusBasedOnCSSSelector(cssSelector: string) {
  const accessibleElements = document.querySelectorAll(cssSelector)

  accessibleElements.forEach((e: Element) => {
    blockFocus(e)
  })
}

export function blockFocus(element: Element) {
  element.setAttribute('tabindex', '-1')
  element.setAttribute('aria-hidden', 'true')
}

export function setSkipToCustomClickEvent() {
  const skipToMainContent = document.getElementsByClassName('vue-skip-to__link')[0]
  skipToMainContent?.addEventListener('click', focusOnMainContent)
}

export function updateSkipToAriaLabel() {
  const skipToMainContent = document.getElementsByClassName('vue-skip-to__link')[0]
  const mainContentH1 = document.getElementById('skip-to-main-content-start')

  if (mainContentH1 === null) {
    return
  }

  skipToMainContent.setAttribute(
    'aria-label',
    `${skipToMainContent.textContent} :  ${
      mainContentH1.getAttribute('aria-label') ?? mainContentH1.innerText
    }`
  )
}

function focusOnMainContent() {
  setFocusForAccessibility('skip-to-main-content-start')
}

export function useFocusOnAvailabilityButton() {
  const availabitiliesButton = document.querySelectorAll('.availability-btn[read]')
  return availabitiliesButton.length
}

export function isThereNewAvailabilityButton() {
  const availabitiliesButton = document.querySelectorAll('.availability-btn[new]')
  return availabitiliesButton.length
}

export function getNextAvailabilityButton() {
  if (!isThereNewAvailabilityButton()) {
    return
  }
  const availabitiliesButton = document.querySelectorAll('.availability-btn[new]')
  setFocusForAccessibility(availabitiliesButton[0].getAttribute('id'), 1000)
}

/**
 * Used to know which element has already been focused on.
 */
export function markHasRead(e: { target: HTMLElement }) {
  e.target.removeAttribute('new')
  e.target.setAttribute('read', true)
}
